import SectionHeading from "@/components/base/SectionHeading";
import { platformFeatures } from "@/mocks/content";

const processSteps = [
  {
    step: "01",
    title: "采点与核实",
    desc: "先确认现场是否真实、机位是否安全，再决定要不要开信号。",
    icon: "ri-map-pin-user-line",
  },
  {
    step: "02",
    title: "架设机位",
    desc: "固定机位优先，移动跟拍次之，尽量不打扰现场秩序与当事人。",
    icon: "ri-camera-lens-line",
  },
  {
    step: "03",
    title: "双通道回传",
    desc: "主备两条链路同时推流，弱网自动降码率，保证画面不断。",
    icon: "ri-signal-tower-line",
  },
  {
    step: "04",
    title: "页面呈现",
    desc: "标注时间戳并开启连麦，让画面与声音互相印证。",
    icon: "ri-live-line",
  },
];

export default function PlatformSection() {
  return (
    <section className="w-full border-y border-background-200/70 bg-background-100 px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="How It Works"
        title="让画面自己说话的四件事"
        desc="我们不做二次摆拍，也不靠夸张标题吸引点击。信号从现场到页面的每一步，都尽量保持原样。"
      />

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:mt-10 md:gap-5">
        {platformFeatures.map((item) => (
          <article
            key={item.title}
            className="flex flex-col gap-3 rounded-lg border border-background-200/70 bg-background-50 p-5"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100/70 text-secondary-700">
              <i className={`${item.icon} text-xl`} aria-hidden="true" />
            </span>
            <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
            <p className="text-[13px] leading-relaxed text-foreground-600">{item.desc}</p>
          </article>
        ))}
      </div>

      <div className="mt-12 rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-8">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            一路信号是怎么送到你眼前的
          </h3>
          <p className="font-label text-xs text-foreground-500">
            平均从采点到画面呈现：18 分钟
          </p>
        </div>

        <ol className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {processSteps.map((step) => (
            <li key={step.step} className="relative pl-12">
              <span
                className="absolute left-0 top-0 flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-label text-xs font-bold text-background-50"
                aria-hidden="true"
              >
                {step.step}
              </span>
              <h4 className="flex items-center gap-1.5 font-heading text-sm font-bold text-foreground-950">
                <i className={`${step.icon} text-primary-500`} aria-hidden="true" />
                {step.title}
              </h4>
              <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}